const shapes = {
  join: '<rect x="3" y="3" width="22" height="22" rx="5"/><path d="m8 14 4 4 8-9"/>',
  back: '<path d="M25 14H3m10-10L3 14l10 10"/>',
  play: '<path d="m8 3 17 11L8 25Z"/>',
};

export function menuIcon(kind: keyof typeof shapes): string {
  return `<svg class="online-action-icon" viewBox="0 0 28 28" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">${shapes[kind]}</svg>`;
}
